export default __webpack_public_path__ + "static/tone1-123976d8871c1ec34ce29ad52b17f1b9.svg";